import * as Yup from 'yup';
import { getRequiredText } from '../../../../../global/helpers/transformer';
import { LabelSettingProps } from '../../../../../global/models/epi-model';
import { EmploymentProps } from '../../../models/arc-epi-props';

export interface AddUnpaidLeaveFormModel {
	employment_id: number,
	start_date: string,
	acknowledge: boolean,
}

export const AddUnpaidLeaveValidationSchema = (employmentProps: EmploymentProps, labelSettings: LabelSettingProps) => {
	return Yup.object().shape({
		start_date: Yup.date().nullable().required(getRequiredText(labelSettings.requiredFormat, employmentProps.startDateLabel)),
		acknowledge: Yup.boolean().required(employmentProps.termsAndConditionMessage)
			.oneOf([true], employmentProps.termsAndConditionMessage),
	});
};